import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation  } from 'react-router-dom';

import { Box, CircularProgress, Snackbar, Alert, Button  } from '@mui/material';
import { Add, Place, FolderOpen } from '@mui/icons-material';

import useErrorManager from "../../hooks/useErrorManager";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import PageContainer from '../Layout/PageContainer';
import GenericTable from '../Layout/Table/GenericTable';
import TextFilter from "../Layout/Table/TextFilter"
import TextLinkButton from "../Layout/TextLinkButton"

import { useBreadcrumb } from '../../contexts/BreadcrumbContext'; // Import breadcrumb context
import { useNotification } from '../../contexts/NotificationContext';


function Locations() {
    const [locations, setLocations] = useState([]);
    const [filterText, setFilterText] = useState("");

    const [loading, setLoading] = useState(true);

    const { setError, clearError, getError } = useErrorManager();
    const { showNotification } = useNotification();
    const { updateBreadcrumb } = useBreadcrumb(); // Use breadcrumb context to update breadcrumb

    const location = useLocation();
    const navigate = useNavigate();
    const axiosInstance = useAxiosPrivate();


    const columns = [
        { id: 'name', label: 'Name', filtered: true, 
            render: (item) => {
                const Icon = item.type === 'Group' ? FolderOpen : Place;
                return <TextLinkButton action={() =>navigate(`/locations/${item.id}`)} text={ item.name }/> //<><Icon style={{ marginRight: '5px' }}/> {item.name}</>
            }
        },
        // { id: 'customerLocationId', label: 'ID' },
        // { id: 'type', label: 'Type' },
        { id: 'description', label: 'Description', filtered: true },
        // { id: 'locations', label: 'Locations', 
        //     render: (item) => {
        //         return item.children ? item.children.length : '';
        //     } 
        // },
        { id: 'gatewayCount', label: 'Gateways' },
        { id: 'handledNetworkCnt', label: 'Networks' },
    ];

    const groupRules = {
        roleColumn: 'type',    //item column that contains the type
        parentValue: 'Group',       //the value of the identifierAttribute for the groupItem
        parentColumn: 'id',         //the item column used to search for the group
        childColumn: 'parentId'     //the item column used to identify the group parent
    };

    useEffect(() => {
        if (location.state?.success) {
            showNotification(location.state.success);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state]);

    useEffect(() => {
        const fetchLocations = async () => {
            try {
                const response = await axiosInstance.get('/locations/list', {
                    withCredentials: true,
                });
                setLocations(response.data);
                clearError('fetch');
                setLoading(false);
            } catch (error) {
                setError('fetch', error.message);
                setLoading(false);
            }
        };

        updateBreadcrumb([
            { label: 'Manage Locations'}
        ]);

        fetchLocations();
    }, []);

    const handleFilterChange = (event) => {
        setFilterText(event.target.value);
    };

    

    return (
            <PageContainer>
            {loading ? (
                    <CircularProgress />
                ) : getError('fetch') ? (
                    <Snackbar open={true} autoHideDuration={6000}>
                        <Alert severity="error">{getError('fetch')}</Alert>
                    </Snackbar>
                ) : (
                    <> 
                        <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="10px">
                        <TextFilter
                            columns={columns}
                            onFilterChange={handleFilterChange}
                        />
                        <Button onClick={() => navigate(`/locations/create`)} variant="contained" color="primary">
                            <Add/>
                        </Button>
                        </Box>
                        
                        <GenericTable
                            items={locations}
                            columns={columns}
                            filterText={filterText}
                            // groupRules={groupRules}
                        />
                    </>
                )}
            </PageContainer>
    );
}

export default Locations;
